import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { generateEnhancedShareUrl } from '../../masonry-utils';
import ShareBtn from './ShareBtn';

class FacebookShareBtn extends ShareBtn {
  static get properties() {
    return {
      ...super.properties,
      post: { type: Object },
    };
  }

  constructor() {
    super();
    this.icon = faFacebookF;
    this.color = '#4267B2';
  }

  /**
   * Gets the Facebook share URL with enhanced URL tracking
   * @returns {string} Facebook share URL
   */
  get shareURL() {
    const url = this.post ? generateEnhancedShareUrl(this.post) : window.location.href;
    return `https://www.facebook.com/sharer.php?u=${encodeURIComponent(url)}`;
  }
}

export default FacebookShareBtn;
